module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-3.53af472b.mp3";